import { IGrantAmendmentData, IGrantAmendment, IGrantAmendmentDetail } from './grantAmendment.types';
import { ValidationMessage, IValidationMessage } from '../common'

/** class for Grant */
export class GrantAmendmentData implements IGrantAmendmentData {

    grantAmendment: IGrantAmendment
    grantAmendmentDetail: IGrantAmendmentDetail
    grantAmendmentDetailData: any
    amendmentRequests: any
    grantInfo: any
    grantData: any
    schema: any
    showValidationDilog: boolean
    validationMessages: Array<IValidationMessage>
    indicators: any
    allowCustomIndicator: any

    constructor(grantAmendment: IGrantAmendmentData) {
        this.grantAmendment = grantAmendment.grantAmendment || {} as IGrantAmendment;
        this.grantAmendmentDetail = grantAmendment.grantAmendmentDetail || {} as IGrantAmendmentDetail;
        this.grantAmendmentDetailData = grantAmendment.grantAmendmentDetailData || {};
        this.grantInfo = grantAmendment.grantInfo || {};
        this.grantData = grantAmendment.grantData || {};
        this.schema = grantAmendment.schema || {};
        this.showValidationDilog = grantAmendment.showValidationDilog || false;
        this.validationMessages = (grantAmendment.validationMessages || []).map((x) => new ValidationMessage(x));
        this.allowCustomIndicator = grantAmendment.allowCustomIndicator;
    }
}

export class GrantAmendment implements IGrantAmendment {
    GrantAmendmentId: number
    GrantId: number
    UniqueID: string
    Code: string
    AmendmentTypeId: number
    Reason: string
    ApplicantId: number
    Applicant: string
    StartDate: Date
    EndDate: Date
    RevisedEndDate: Date
    RequestedAmount: number
    TotalProjectBudget: number
    RevisedRequestedAmount: number
    RevisedTotalProjectBudget: number
    PrimaryProgramOfficerId: number
    IsAgreementSigned: number
    AgreementDate: Date
    AgreementSignedBy: number
    WorkflowStatusId: number
    WorkflowStatusCode: string
    Comments: string
    CreatedById: string
    CreatedDate: Date
    UpdatedById: Date
    UpdatedDate: Date
    RevisionNumber: number
    WorkflowInfo: any
    Subject: string
    notify: boolean
    constructor(grantAmendment: IGrantAmendment) {
        this.GrantAmendmentId = grantAmendment.GrantAmendmentId
        this.GrantId = grantAmendment.GrantId
        this.UniqueID = grantAmendment.UniqueID
        this.Code = grantAmendment.Code
        this.AmendmentTypeId = grantAmendment.AmendmentTypeId
        this.Reason = grantAmendment.Reason
        this.ApplicantId = grantAmendment.ApplicantId
        this.Applicant = grantAmendment.Applicant
        this.StartDate = grantAmendment.StartDate
        this.EndDate = grantAmendment.EndDate
        this.RevisedEndDate = grantAmendment.RevisedEndDate
        this.RequestedAmount = grantAmendment.RequestedAmount
        this.TotalProjectBudget = grantAmendment.TotalProjectBudget
        this.RevisedRequestedAmount = grantAmendment.RevisedRequestedAmount
        this.RevisedTotalProjectBudget = grantAmendment.RevisedTotalProjectBudget
        this.PrimaryProgramOfficerId = grantAmendment.PrimaryProgramOfficerId
        this.IsAgreementSigned = grantAmendment.IsAgreementSigned
        this.AgreementDate = grantAmendment.AgreementDate
        this.AgreementSignedBy = grantAmendment.AgreementSignedBy
        this.WorkflowStatusId = grantAmendment.WorkflowStatusId
        this.WorkflowStatusCode = grantAmendment.WorkflowStatusCode
        this.Comments = grantAmendment.Comments
        this.CreatedById = grantAmendment.CreatedById
        this.CreatedDate = grantAmendment.CreatedDate
        this.UpdatedById = grantAmendment.UpdatedById
        this.UpdatedDate = grantAmendment.UpdatedDate
        this.RevisionNumber = grantAmendment.RevisionNumber
        this.WorkflowInfo = grantAmendment.WorkflowInfo
        this.Subject = grantAmendment.Subject
        this.notify = grantAmendment.notify
    }
}

export class GrantAmendmentDetail implements IGrantAmendmentDetail {
    GrantAmendmentDetailId: number
    GrantAmendmentId: number
    AmendmentTypeId: number
    ApplicationId: number
    UniqueID: string
    ApprovedId: number
    ApproverDate: Date
    AgreementDate: Date
    IndirectCost: number
    WorkflowStatusId: number
    WorkflowStatusCode: string
    Comments: string
    CreatedById: string
    CreatedDate: Date
    UpdatedById: Date
    UpdatedDate: Date
    RevisionNumber: number
    WorkflowInfo: any
    Subject: string
    notify: boolean
    constructor(grantAmendmentDetail: IGrantAmendmentDetail) {
        this.GrantAmendmentDetailId = grantAmendmentDetail.GrantAmendmentDetailId
        this.GrantAmendmentId = grantAmendmentDetail.GrantAmendmentId
        this.AmendmentTypeId = grantAmendmentDetail.AmendmentTypeId
        this.ApplicationId = grantAmendmentDetail.ApplicationId
        this.UniqueID = grantAmendmentDetail.UniqueID
        this.ApprovedId = grantAmendmentDetail.ApprovedId
        this.ApproverDate = grantAmendmentDetail.ApproverDate
        this.IndirectCost = grantAmendmentDetail.IndirectCost
        this.WorkflowStatusId = grantAmendmentDetail.WorkflowStatusId
        this.WorkflowStatusCode = grantAmendmentDetail.WorkflowStatusCode
        this.Comments = grantAmendmentDetail.Comments
        this.CreatedById = grantAmendmentDetail.CreatedById
        this.CreatedDate = grantAmendmentDetail.CreatedDate
        this.UpdatedById = grantAmendmentDetail.UpdatedById
        this.UpdatedDate = grantAmendmentDetail.UpdatedDate
        this.RevisionNumber = grantAmendmentDetail.RevisionNumber
        this.WorkflowInfo = grantAmendmentDetail.WorkflowInfo
        this.Subject = grantAmendmentDetail.Subject
        this.notify = grantAmendmentDetail.notify
    }
}